import React from 'react';

import {Text} from '@albert-io/atomic';
import {AdaptiveOnboardingEmptyState} from 'client/TeacherDashboard/components/AdaptiveEmptyState';
import {AdaptiveSubjectLinks} from 'client/TeacherDashboard/components/AdaptiveSubjectLinks';
import {EmptyState, EmptyIllustration} from 'client/TeacherDashboard/components/EmptyState';
import {useAdaptiveEmptyStateSubjects} from 'client/TeacherDashboard/components/useAdaptiveEmptyStateSubjects';

import {STATUS_SEGMENTS} from './constants';
import type {SkillPathStatusSegment} from './types';

const statusLabel = (segment: SkillPathStatusSegment): string =>
  STATUS_SEGMENTS.find((s) => s.value === segment)?.label ?? '';

/** No skill paths in any status under the current filters. */
export const SkillPathsOnboardingEmptyState = ({classroomId}: {classroomId?: string}) => (
  <AdaptiveOnboardingEmptyState classroomId={classroomId} variant='skillPaths' />
);

/** The current status tab is empty while another status still has skill paths. */
export const SkillPathStatusEmptyState = ({
  segment,
  classroomId
}: {
  segment: SkillPathStatusSegment;
  classroomId?: string;
}) => {
  const {subjects, loading} = useAdaptiveEmptyStateSubjects(classroomId);
  return (
    <EmptyState
      action={loading ? null : <AdaptiveSubjectLinks subjects={subjects} />}
      illustration={
        <EmptyIllustration
          badgeClassName='background-special-subtle content-special'
          icon='diagram-project'
        />
      }
    >
      <Text as='div' size='l'>
        No {statusLabel(segment)} Skill Paths
      </Text>
    </EmptyState>
  );
};

export const SkillPathStatusEmptyLine = ({segment}: {segment: SkillPathStatusSegment}) => (
  <Text color='secondary'>No {statusLabel(segment).toLowerCase()} skill paths</Text>
);
